// @flow
import React, { PureComponent } from 'react';
import { Image, ScrollView, StyleSheet, View } from 'react-native';
import {SafeAreaView} from 'react-native-safe-area-context';
import { BulletPoint, Text } from 'trpc-react-native-ui';
import { FullButton } from '../../components/common';
import I18n from '../../lib/i18n';
import theme from '../../theme-config';

export default class SimReplacement extends PureComponent<Props> {
  bulletPoints = [I18n.t('Dashboard.SimReplacement.bulletPoint1'), I18n.t('Dashboard.SimReplacement.bulletPoint2')];

  render() {
    const styles = getStyles();

    if (!this.props.hasVisibleSubscriptions && !this.props.hasSubscriptionToActivate) {
      return (
        <View style={styles.emptyContainer}>
          <Image source={theme.terminationImage} style={styles.image} />
          <Text style={styles.emptyText}>{I18n.t('Dashboard.SimReplacement.noSimToReplace')}</Text>
        </View>
      );
    }

    return (
      <SafeAreaView style={styles.safeareaview} edges={['bottom', 'left', 'right']}>
        <View style={styles.container}>
          <ScrollView contentContainerStyle={styles.contentContainer}>
            <Image source={theme.simReplacementImage} style={styles.image} />
            <Text style={styles.needReplacementSim}>{I18n.t('Dashboard.SimReplacement.needReplacementSim')}</Text>
            <View style={styles.bulletPointsContainer}>
              {this.bulletPoints.map((bulletPoint, index) => (
                <BulletPoint
                  key={index}
                  text={bulletPoint}
                  containerStyle={styles.bulletPointContainerStyle}
                  bulletPointStyle={styles.bulletPointStyle}
                  textStyle={styles.bulletPointTextStyle}
                />
              ))}
            </View>
          </ScrollView>
          <View style={styles.bottomPanel}>
            <FullButton
              text={I18n.t('Dashboard.SimReplacement.order')}
              onPress={this.props.initSimReplacement}
              isLoading={this.props.isLoading}
            />
          </View>
        </View>
      </SafeAreaView>
    );
  }
}

type Props = DispatchProps & StateProps;

export type DispatchProps = {
  initSimReplacement: Function,
};

export type StateProps = {
  isLoading: boolean,
  hasVisibleSubscriptions: boolean,
  hasSubscriptionToActivate: boolean,
};

const getStyles = () =>
  StyleSheet.create({
    safeareaview: {
      flex: 1,
      backgroundColor: 'transparent',
    },
    container: {
      flex: 1,
    },
    contentContainer: {
      alignItems: 'center',
      margin: 15,
    },
    bulletPointsContainer: {
      flex: 1,
      marginBottom: 15,
    },
    needReplacementSim: {
      fontSize: 22,
      textAlign: 'center',
      marginBottom: 30,
    },
    bulletPointContainerStyle: {
      alignItems: 'flex-start',
      marginLeft: 20,
    },
    bulletPointStyle: {
      color: theme.defaultTextColor,
      marginTop: 7,
      fontSize: 12,
    },
    bulletPointTextStyle: {
      fontSize: 18,
      paddingRight: 30,
    },
    image: {
      width: 100,
      height: 100,
      marginTop: 16,
      marginBottom: 29,
    },
    bottomPanel: {
      paddingVertical: 13,
      paddingHorizontal: 20,
      justifyContent: 'center',
      borderTopWidth: 1,
      borderTopColor: theme.bottomPanelBorderColor,
    },
    emptyContainer: {
      flex: 1,
      alignItems: 'center',
      justifyContent: 'center',
    },
    emptyText: {
      textAlign: 'center',
      color: theme.emptyTextColor,
      fontSize: 16,
    },
    image: {
      width: 100,
      height: 100,
      marginTop: 40,
      marginBottom: 40,
      resizeMode: 'contain',
    },
  });
